import React from 'react';
import { faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { faEllipsisV } from '@fortawesome/pro-solid-svg-icons';
import { useFeatureFlag } from 'src/common/hooks';
import { FeatureFlagName } from 'src/common/constants';
import RightArrowSvg from 'src/images/svgs/manage-room/right-arrow.svg';
import { StyledBar, StyledChevronUp, StyledEllipsesIcon, StyledIcon, StyledImg, StyledLine, StyledNavigationContainer, StyledOption, StyledOptionName, StyledOptionWrapper, StyledResponsiveContainer } from './manage-room-navigation.styles';
import { cloudIntegrationTab, manageRoomTabs } from './manage-room-navigation.constants';
import { ManageRoomNavigationProps } from './manage-room-navigation.types';
export const ManageRoomNavigation = ({
  isContentDev,
  selectedTab,
  onSelectedTab
}: ManageRoomNavigationProps) => {
  const [expanded, setExpanded] = React.useState<boolean>(true);
  const {
    enabled: isAzureCloudTrainingEnabled
  } = useFeatureFlag(FeatureFlagName.AZURE_CLOUD_TRAINING);
  let tabs = manageRoomTabs;
  if (isContentDev && isAzureCloudTrainingEnabled) {
    tabs = [...tabs.slice(0, 1), cloudIntegrationTab, ...tabs.slice(1)];
  }
  return <StyledNavigationContainer aria-label="Manage room navigation" data-sentry-element="StyledNavigationContainer" data-sentry-component="ManageRoomNavigation" data-sentry-source-file="manage-room-navigation.tsx">
      {expanded ? <>
          {tabs.map(tab => {
        const isSelected = selectedTab.key === tab.key;
        return <StyledOptionWrapper key={tab.key}>
                {isSelected && <StyledImg alt="Selected Option" src={RightArrowSvg} />}

                <StyledOption isSelected={isSelected} aria-label={`${tab.name}`} onClick={() => onSelectedTab(tab)}>
                  <StyledIcon icon={isSelected ? tab.selectedIcon : tab.icon} />
                  <StyledOptionName>{tab.name}</StyledOptionName>
                </StyledOption>
              </StyledOptionWrapper>;
      })}
        </> : <StyledOptionWrapper>
          <StyledImg alt="Selected Option" src={RightArrowSvg} />
          <StyledOption isSelected aria-label={`${selectedTab.name}`}>
            <StyledIcon icon={selectedTab.selectedIcon} />
            <StyledOptionName>{selectedTab.name}</StyledOptionName>
          </StyledOption>

          <StyledEllipsesIcon icon={faEllipsisV} onClick={() => setExpanded(true)} />
        </StyledOptionWrapper>}

      {expanded && <StyledResponsiveContainer>
          <StyledLine />
          <StyledChevronUp data-testid="chevronup-icon" icon={faChevronUp} onClick={() => setExpanded(!expanded)} />
        </StyledResponsiveContainer>}

      <StyledBar data-sentry-element="StyledBar" data-sentry-source-file="manage-room-navigation.tsx" />
    </StyledNavigationContainer>;
};